import { CDropdownMenu, CDropdownItem } from '@coreui/react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ModalBookingCancel from '../views/bookings/V2/ModalCancelConfirmation';
import ModalSentEmailDetail from '../views/conversation/sent/ModalSentMsgsDetail';
import AddBookingV2 from '../views/bookings/V2/AddBookingV2';
import AddBlockV2 from '../views/bookings/V2/AddBlockV2';
import EditBlockV2 from '../views/bookings/V2/EditBlockV2';
import EditBookingV2 from '../views/bookings/V2/EditBookingV2';
import ModalBookingDetails from '../views/bookings/ModalBookingDetails';
import BookingDetailsV2Modal from '../views/bookings/V2/BookingDetailsV2Modal';
import AddOffer from '../views/offers/AddOffer';
import BuildingDetails from '../views/properties/Building/BuildingDetails';
import OrganizationDetails from '../views/properties/Organization/OrganizationDetails';
import AddAmenity from '../views/properties/Unit&Amenities/Amenities/AddAmenities';
import AddAmenitiesV2 from '../views/properties/Unit&Amenities/Amenities/V2/AddAmenitiesV2';
import UpdateAmenityV2 from '../views/properties/Unit&Amenities/Amenities/V2/UpdateAmenityV2';
import AmenityDetailV2 from '../views/properties/Unit&Amenities/Amenities/V2/AmenityDetailV2';
import AmenityCreateResultModalV2 from '../views/properties/Unit&Amenities/Amenities/V2/AmenityCreateResultModalV2';
import AddUnit from '../views/properties/Unit&Amenities/Unit/AddUnit';
import EditRoom from '../views/properties/Unit&Amenities/Unit/EditRoom';
import AddUnitsFromCSVModal from '../views/properties/Unit&Amenities/Unit/AddUnitsFromCSVModal';
import OperatorLogs from '../views/properties/Unit&Amenities/Unit/OperatorLogs';
import UnitDetails from '../views/properties/Unit&Amenities/Unit/UnitDetails';
import UnitLockDetails from '../views/properties/Unit&Amenities/Unit/UnitLockDetails';
import UnitStatistics from '../views/properties/Unit&Amenities/Unit/UnitStatistics';
import ServiceCreate from '../views/services/ServiceCreate';
import ServiceDetail from '../views/services/ServiceDetail';
import ServiceDetailEdit from '../views/services/ServiceDetailEdit';
import AddUser from '../views/users/AddUser';
import AddUsersFromCSV from '../views/users/AddUsersFromCSV';
import EditUser from '../views/users/EditUser';
import UserDetailModal from '../views/users/UserDetailModal';
import EditModalContent from '../views/bookings/BlankModalContent';
import PMActivities from '../views/pm-analytics/orgs/PMActivities';
import GlobalPushNotificationModal from '../views/pushnotification/GlobalPushNotificationModal';
import CreateProfileImageModal from '../views/settings/CreateProfileImageModal';
import CreateProfileModalFinal from '../views/settings/CreateProfileModalFinal';
import SecurityPreferencesModal from '../views/settings/SecurityPreferencesModal';
import AddNewUserTypeModalStep1 from '../views/manage-users/AddUserTypeModalFlow/AddNewUserTypeModalStep1';
import AddNewUserTypeModalStep2 from '../views/manage-users/AddUserTypeModalFlow/AddNewUserTypeModalStep2';
import AddNewUserTypeModalStep3 from '../views/manage-users/AddUserTypeModalFlow/AddNewUserTypeModalStep3';
import AddNewUserTypeModalStep4 from '../views/manage-users/AddUserTypeModalFlow/AddNewUserTypeModalStep4';
import CreateProfileModal from '../views/settings/CreateProfileModal';
import Help from '../components/Help';
import AddDeliveryCode from '../views/delivery-codes/AddDeliveryCode';
import styled from 'styled-components';
import EditDataCenter from '../components/EditDataCenter';
import AddSuite from '../views/properties/Unit&Amenities/Suites/AddSuite';
import EditSuite from '../views/properties/Unit&Amenities/Suites/EditSuite';
import SuiteLockDetails from '../views/properties/Unit&Amenities/Suites/SuiteLockDetails';
import ViewDeliveryModal from '../views/Deliveries/ViewDeliveryModal';
import AddEditDelivery from '../views/Deliveries/AddEditDelivery/AddEditDelivery';
import ViewDocumentModal from '../views/documents/ViewDocumentModal';
import AddEditDocumentModal from '../views/documents/AddEditDocumentModal';
import AddEditFolderModal from '../views/documents/AddEditFolderModal';
import AddEditEvent from '../views/events/AddEditEvent';
import EventDetails from '../views/events/EventDetails';
import ReactivateUserModal from '../views/manage-users/ReactivateUser/ReactivateUserModal';
import ThermostatDetailsModal from '../views/thermostats/ThermostatDetailsModal';
import LeakDetectorsDetailsModal from '../views/leak-detectors/LeakDetectorsDetailsModal';
import AddLicensePlateModal from '../views/license-plates/AddOrEditLicensePlateModal';
import LicensePlateDetailsModal from '../views/license-plates/LicensePlateDetailsModal';
import AddOrEditLicensePlateModal from '../views/license-plates/AddOrEditLicensePlateModal';
import LicensePlateScanDetailsModal from '../views/license-plate-scans/LicensePlateScanDetailsModal';
import EditProject from '../components/EditProject';
import { GlobalThermostatControlModal } from '../views/thermostats/GlobalThermostatControlModal';
import { ThermostatControlModal } from '../views/thermostats/ThermostatControlModal';
import { CustomThermostatControlModal } from '../views/thermostats/CustomThermostatControlModal';
import AddNewUserTypeModalStepAccessControl from '../views/manage-users/AddUserTypeModalFlow/AddNewUserTypeModalStepAccessControl';
import AddEditOrganization from '../views/properties/Organization/AddEditOrganization';
import AddEditBuilding from '../views/properties/Building/AddEditBuilding';
import ViewUnitIntercomPinsModal from '../views/intercom/Modals/ViewUnitIntercomPinsModal';
import PinHistoryModal from '../views/properties/Unit&Amenities/Unit/PinHistoryModal';
import EditUserIntercomPinModal from '../views/intercom/Modals/EditUserIntercomPinModal';
import ViewIntercomUserModal from '../views/intercom/Modals/ViewIntercomUserModal';
import DeleteIntercomUserModal from '../views/intercom/Modals/DeleteIntercomUserModal';
import EditIntercomSettingsModal from '../views/intercom/Modals/EditIntercomSettingsModal';
import AccountNotSetupModal from '../views/payments/modals/AccountSetup/BankingDetails/AccountNotSetupModal';
import AccountSuccessSetupModal from '../views/payments/modals/AccountSetup/BankingDetails/AccountSuccessSetupModal';
import CreateRecurringPaymentStep1 from '../views/payments/modals/AccountSetup/CreatePayment/Recurring/CreateRecurringPaymentStep1';
import CreateRecurringPaymentStep2 from '../views/payments/modals/AccountSetup/CreatePayment/Recurring/CreateRecurringPaymentStep2';
import CreateRecurringPaymentStep3 from '../views/payments/modals/AccountSetup/CreatePayment/Recurring/CreateRecurringPaymentStep3';
import CreatePaymentModal from '../views/payments/modals/CreatePayment/CreatePaymentModal';
import SetupBankingDetailsStep1 from '../views/payments/modals/AccountSetup/BankingDetails/SetupBankingDetailsStep1';
import SetupBankingDetailsStep2 from '../views/payments/modals/AccountSetup/BankingDetails/SetupBankingDetailsStep2';
import SelectPaymentTypeModal from '../views/payments/modals/CreatePayment/SelectPaymentTypeModal';
import CreateOneTimePaymentStep1 from '../views/payments/modals/AccountSetup/CreatePayment/OneTime/CreateOneTimePaymentStep1';
import CreateOneTimePaymentStep2 from '../views/payments/modals/AccountSetup/CreatePayment/OneTime/CreateOneTimePaymentStep2';
import PaymentDetailsSideModal from '../views/payments/modals/InvoiceDetailDirectDeposit/PaymentDetailsSideModal';
import CancelInvoiceConfirmation from '../views/payments/modals/InvoiceDetailDirectDeposit/CancelInvoiceConfirmation';
import RefundPaymentConfirmation from '../views/payments/modals/InvoiceDetailDirectDeposit/RefundPaymentConfirmation';
import PaymentReceiptSideModal from '../views/payments/modals/InvoiceDetailDirectDeposit/PaymentReceiptSideModal';
import OnboardingModal from '../views/payments/modals/Onboarding/OnboardingModal';
import PaymentsDownloadCsvModal from '../views/payments/modals/DownloadCsv/PaymentsDownloadCsvModal';
import ConfirmationModal from '../views/intercom/Modals/ConfirmationModal';
import AddNewUserTypeModalStepBuildingManagerAccess from '../views/manage-users/AddUserTypeModalFlow/AddNewUserTypeModalStepBuildingManagerAccess';

const TheHeaderDropDownModal = () => {
  const { modal } = useSelector((state) => state.headerModal);

  useEffect(() => {
    const body = document.querySelector('body');
    body.style.overflow = Boolean(modal) ? 'hidden' : 'auto';
  }, [modal]);

  return (
    <div>
      {modal === 'serviceDetail' ? (
        <ServiceDetail />
      ) : modal === 'serviceDetailEdit' ? (
        <ServiceDetailEdit />
      ) : modal === 'ModalEditProject' ? (
        <EditProject />
      ) : modal === 'ModalEditDataCenter' ? (
        <EditDataCenter />
      ) : modal === 'createService' ? (
        <ServiceCreate />
      ) : modal === 'addBookingV2' ? (
        <AddBookingV2 />
      ) : modal === 'modalAddBlock' ? (
        <AddBlockV2 />
      ) : modal === 'showSentMessageModal' ? (
        <ModalSentEmailDetail />
      ) : modal === 'addBuilding' || modal === 'editBuilding' ? (
        <AddEditBuilding />
      ) : modal === 'addOrganization' || modal === 'editOrganization' ? (
        <AddEditOrganization />
      ) : modal === 'addUnit' ? (
        <AddUnit />
      ) : modal === 'AddUser' ? (
        <AddUser />
      ) : modal === 'AddUnitsFromCSV' ? (
        <AddUnitsFromCSVModal />
      ) : modal === 'AddUsersFromCSV' ? (
        <AddUsersFromCSV />
      ) : modal === 'AddOffer' ? (
        <AddOffer />
      ) : modal === 'addAmenity' ? (
        <AddAmenity />
      ) : modal === 'addAmenityV2' ? (
        <AddAmenitiesV2 />
      ) : modal === 'updateAmenityV2' ? (
        <UpdateAmenityV2 />
      ) : modal === 'amenityDetailV2' ? (
        <AmenityDetailV2 />
      ) : modal === 'amenityCreateResult' ? (
        <AmenityCreateResultModalV2 />
      ) : modal === 'editBlockV2Loading' || modal === 'editBlockV2' ? (
        <EditBlockV2 />
      ) : modal === 'editBookingV2Loading' || modal === 'editBookingV2' ? (
        <EditBookingV2 />
      ) : modal === 'editBookingLoading' || modal === 'editBooking' ? (
        <EditModalContent />
      ) : modal === 'editUser' ? (
        <EditUser />
      ) : modal === 'editRoom' ? (
        <EditRoom />
      ) : modal === 'unitLockDetails' ? (
        <UnitLockDetails />
      ) : modal === 'unitStatistics' ? (
        <UnitStatistics />
      ) : modal === 'UnitDetail' ? (
        <UnitDetails />
      ) : modal === 'helpModal' ? (
        <Help />
      ) : modal === 'AddDeliveryCode' ? (
        <AddDeliveryCode />
      ) : modal === 'OperatorLogs' ? (
        <OperatorLogs />
      ) : modal === 'GlobalPushNotification' ? (
        <GlobalPushNotificationModal />
      ) : modal === 'PMActivitiesDetails' ? (
        <PMActivities />
      ) : modal === 'CreateProfileModal' ? (
        <CreateProfileModal />
      ) : modal === 'CreateProfileImageModal' ? (
        <CreateProfileImageModal />
      ) : modal === 'CreateProfileModalFinal' ? (
        <CreateProfileModalFinal />
      ) : modal === 'SecurityPreferencesModal' ? (
        <SecurityPreferencesModal />
      ) : modal === 'AddNewUserTypeModalStep1' ? (
        <AddNewUserTypeModalStep1 />
      ) : modal === 'AddNewUserTypeModalStep2' ? (
        <AddNewUserTypeModalStep2 />
      ) : modal === 'AddNewUserTypeModalStep3' ? (
        <AddNewUserTypeModalStep3 />
      ) : modal === 'AddNewUserTypeModalStep4' ? (
        <AddNewUserTypeModalStep4 />
      ) : modal === 'AddNewUserTypeModalStepAccessControl' ? (
        <AddNewUserTypeModalStepAccessControl />
      ) : modal === 'ReactivateUserModal' ? (
        <ReactivateUserModal />
      ) : modal === 'addSuite' ? (
        <AddSuite />
      ) : modal === 'editSuite' ? (
        <EditSuite />
      ) : modal === 'suiteLockDetails' ? (
        <SuiteLockDetails />
      ) : modal === 'viewDeliveryModal' ? (
        <ViewDeliveryModal />
      ) : modal === 'addEditDelivery' ? (
        <AddEditDelivery />
      ) : modal === 'viewDocumentModal' ? (
        <ViewDocumentModal />
      ) : modal === 'addEditDocument' ? (
        <AddEditDocumentModal />
      ) : modal === 'addEditFolder' ? (
        <AddEditFolderModal />
      ) : modal === 'addEditEvent' ? (
        <AddEditEvent />
      ) : modal === 'eventDetails' ? (
        <EventDetails />
      ) : modal === 'thermostatDetailsModal' ? (
        <ThermostatDetailsModal />
      ) : modal === 'leakDetectorDetailsModal' ? (
        <LeakDetectorsDetailsModal />
      ) : modal === 'AddOrEditLicensePlateModal' ? (
        <AddOrEditLicensePlateModal />
      ) : modal === 'LicensePlateDetailsModal' ? (
        <LicensePlateDetailsModal />
      ) : modal === 'LicensePlateScanDetailsModal' ? (
        <LicensePlateScanDetailsModal />
      ) : modal === 'GlobalThermostatControlModal' ? (
        <GlobalThermostatControlModal />
      ) : modal === 'ThermostatControlModal' ? (
        <ThermostatControlModal />
      ) : modal === 'CustomThermostatControlModal' ? (
        <CustomThermostatControlModal />
      ) : modal === 'ViewUnitIntercomPinsModal' ? (
        <ViewUnitIntercomPinsModal />
      ) : modal === 'PinHistoryModal' ? (
        <PinHistoryModal />
      ) : modal === 'EditUserIntercomPinModal' ? (
        <EditUserIntercomPinModal />
      ) : modal === 'ViewIntercomUserModal' ? (
        <ViewIntercomUserModal />
      ) : modal === 'DeleteIntercomUserModal' ? (
        <DeleteIntercomUserModal />
      ) : modal === 'editIntercomSettings' ? (
        <EditIntercomSettingsModal />
      ) : modal === 'AccountNotSetupModal' ? (
        <AccountNotSetupModal />
      ) : modal === 'AccountSuccessSetupModal' ? (
        <AccountSuccessSetupModal />
      ) : modal === 'CreateRecurringPaymentStep1' ? (
        <CreateRecurringPaymentStep1 />
      ) : modal === 'CreateRecurringPaymentStep2' ? (
        <CreateRecurringPaymentStep2 />
      ) : modal === 'CreateRecurringPaymentStep3' ? (
        <CreateRecurringPaymentStep3 />
      ) : modal === 'CreatePaymentModal' ? (
        <CreatePaymentModal />
      ) : modal === 'SetupBankingDetailsStep1' ? (
        <SetupBankingDetailsStep1 />
      ) : modal === 'SetupBankingDetailsStep2' ? (
        <SetupBankingDetailsStep2 />
      ) : modal === 'SelectPaymentTypeModal' ? (
        <SelectPaymentTypeModal />
      ) : modal === 'CreateOneTimePaymentStep1' ? (
        <CreateOneTimePaymentStep1 />
      ) : modal === 'CreateOneTimePaymentStep2' ? (
        <CreateOneTimePaymentStep2 />
      ) : modal === 'PaymentDetailsSideModal' ? (
        <PaymentDetailsSideModal />
      ) : modal === 'PaymentReceiptSideModal' ? (
        <PaymentReceiptSideModal />
      ) : modal === 'CancelInvoiceConfirmation' ? (
        <CancelInvoiceConfirmation />
      ) : modal === 'RefundPaymentConfirmation' ? (
        <RefundPaymentConfirmation />
      ) : modal === 'OnboardingModal' ? (
        <OnboardingModal />
      ) : modal === 'PaymentsDownloadCsvModal' ? (
        <PaymentsDownloadCsvModal />
      ) : modal === 'ConfirmationModal' ? (
        <ConfirmationModal />
      ) : modal === 'AddNewUserTypeModalStepBuildingManagerAccess' ? (
        <AddNewUserTypeModalStepBuildingManagerAccess />
      ) : (
        <></>
      )}

      <UserDetailModal />
      <BuildingDetails />
      <OrganizationDetails />
      <ModalBookingDetails />
      <BookingDetailsV2Modal />
      <ModalBookingCancel />
    </div>
  );
};

export default TheHeaderDropDownModal;
